import React from "react";

const Java_Extends = () => {
  return (
    <div>
      <h1>Java Extends</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Extends in Java.</p>
    </div>
  );
};

export default Java_Extends;
